<script>
export default {
  props: ['tags', 'loading', 'filterText'],
  mounted() {
    this.initUserSelectedTags();
  },
  data() {
    return {
      selectableTags: this.tags ? this.tags : [],
      selectedTags: [],
    };
  },
  methods: {
    // First page load add selected tag ids to selectedTags which is comming from the backend
    initUserSelectedTags() {
      this.selectableTags.forEach((tag) => {
        if (tag.selected) {
          this.selectedTags.push(tag.contentlink);
        }
      });
    },
    addRemoveTagFilter(tag) {
      if (!this.selectedTags.includes(tag.contentlink)) {
        this.selectedTags.push(tag.contentlink);
      }

      tag.selected = !tag.selected;

      if (tag.selected === false) {
        this.selectedTags = this.selectedTags.filter((contentlink) => {
          return contentlink !== tag.contentlink;
        });
      }
      this.$emit('handle-selected-tags', this.selectedTags);
    },
  },
};
</script>

<template>
  <div class="newsfilter col-md-10 mt-xs offset-md-1 col-lg-8 offset-lg-2">
    <span class="newsfilter_heading">{{ filterText }}</span>
    <ul class="newsfilter_tags">
      <li v-for="tag in selectableTags">
        <button
          :class="[
            tag.selected
              ? 'filter-button filter-button_selected'
              : 'filter-button',
          ]"
          @click="addRemoveTagFilter(tag)"
          :disabled="loading">
          {{ tag.name }}
        </button>
      </li>
    </ul>
  </div>
</template>
